module.exports = __webpack_public_path__ + "img/03-B03.c6d95750.png";